import { render, staticRenderFns } from "./FileZoomDialog.vue?vue&type=template&id=196e07a2"
import script from "./FileZoomDialog.vue?vue&type=script&lang=js"
export * from "./FileZoomDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports